import { Box, Flex, Image, Text } from "rebass/styled-components";
import styled from "styled-components";
import { Button } from "MVVM/Components/Button";

import AllstarIcon from "assets/images/brand/Wordmark-Light-Tag.png";
import { useHistory } from "react-router-dom";

export const CreatedForFriend = ({
  closePortal,
}: {
  closePortal: () => void;
}) => {
  const history = useHistory();
  return (
    <StyledBox>
      <Flex
        flexDirection="column"
        padding={7}
        justifyContent={"space-between"}
        alignItems={"center"}
        style={{ gap: 20 }}
        maxWidth={400}
      >
        <StyledAllstarIcon src={AllstarIcon} mb={5} />
        <Flex
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          mb={3}
        >
          <Text variant="text.headingSmall" textAlign={"center"} mb={3}>
            Your friend's clip is on the way!
          </Text>
          <Text
            variant="text.paragraphMedium"
            color="chalk"
            maxWidth={450}
            textAlign={"center"}
          >
            You've created your first friend clip. It will be available shortly
            on your profile. Share this clip with your friend and they can claim
            it and add it to their profile just by signing up!
          </Text>
        </Flex>
        <Flex
          flexDirection={"row"}
          style={{ gap: 10 }}
          justifyContent={"end"}
          mt={4}
        >
          <Button
            size="small"
            flex={true}
            classification="secondary"
            onClick={() => {
              closePortal();
            }}
          >
            Got It
          </Button>
        </Flex>
      </Flex>
    </StyledBox>
  );
};

const StyledBox = styled(Box)`
  border-radius: 16px;
  mix-blend-mode: normal;
  width: 100%;
  border-color: #233438;
  border-style: solid;
  border-width: 1px;
  box-shadow: 0 0 30px #233438;
  background-color: #10161a;
  max-width: 400px;
`;

const StyledAllstarIcon = styled(Image)`
  width: 110px;
`;
